import React from 'react';
import { NavLink, Navigate } from 'react-router-dom';
import { BsFillCaretRightFill, BsFillXCircleFill, BsPencilFill, BsSave, BsThreeDots, BsUpload, BsXLg } from 'react-icons/bs';
import { Server } from 'src/server/server';
import { AppConfig } from '../AppConfig';
import AlertModal from '../modals/AlertModal';
import MessageModal from '../modals/MessageModal';
import NotFoundPage from './NotFoundPage';
import AddMediaModal from '../modals/AddMediaModal';
import PageEnvelope from '../elements/PageEnvelope';
import './SitePage.css';
import './AdminPage.css';

interface AdminPageState {
  name: string;
  description: string;
  slug: string;
  public: boolean;
  icon: number;
  icons: string[],
  showIcons: boolean;
  message: string;
  alert: string;
  openAddMedia: boolean;
  editMode: string;
  editSlug: boolean;
}

class AdminPage extends React.Component<{}, AdminPageState> {
  constructor(props:{}) {
    super(props);
    this.state = {
      name: '',
      description: '',
      slug: '',
      public: false,
      icon: 0,
      icons: [],
      showIcons: false,
      message: '',
      alert: '',
      openAddMedia: false,
      editMode: '',
      editSlug: false
    }
  }

  componentDidMount() {
    this.setState({
      name: AppConfig.community.name,
      description: AppConfig.community.description,
      slug: AppConfig.community.slug,
      public: AppConfig.community.public
    });

    this.shuffleIcons();
  }

  shuffleIcons() {
    let icons = [...AppConfig.icons];

    let i = icons.indexOf(AppConfig.icon);
    icons.splice(i, 1);

    for(let i = 0; i < icons.length; i++) {
      let r1 = Math.floor(Math.random() * icons.length);
      let r2 = Math.floor(Math.random() * icons.length);
      let temp = icons[r1];
      icons[r1] = icons[r2];
      icons[r2] = temp;
    }

    // while(icons.length > 4) {
    //   let r = Math.floor(Math.random() * icons.length);
    //   icons.splice(r, 1);
    // }

    if(AppConfig.icon.substring(0, 1) == '/')
      icons.unshift(AppConfig.icon);

    this.setState({icons, icon: 0});
  }

  isInfoDirty() {
    let dirty = false;
    if(AppConfig.community.name != this.state.name) dirty = true;
    if(AppConfig.community.description != this.state.description) dirty = true;
    if(AppConfig.community.slug != this.state.slug) dirty = true;
    if(AppConfig.community.public != this.state.public) dirty = true;
    return dirty;
  }

  onEditSlug() {
    this.setState({alert: 'Changing your subdomain affects all users that already have a link to your site!', editSlug: true})
  }

  onCancelEditSlug() {
    this.setState({editSlug: false, slug: AppConfig.community.slug})
  }

  onSaveInfo() {
    if(!this.isInfoDirty()) {
      this.setState({alert: 'There are no changes to save.'});
      return;
    }
    
    this.setState({message: 'Saving...'});

    setTimeout(async () => {
      let oldSlug = AppConfig.community.slug;
      let oldDesc = AppConfig.community.description;
      let oldPublic = AppConfig.community.public;

      AppConfig.community.name = this.state.name;
      AppConfig.community.description = this.state.description;
      AppConfig.community.slug = this.state.slug;
      AppConfig.community.public = this.state.public;

      let response = await Server.user.updateCommunity(AppConfig.community);
      
      this.setState({message: ''});
      
      if(response.success) {
        if(oldSlug != this.state.slug) {
          let url = window.location.href.replace(oldSlug, AppConfig.community.slug);
          window.location.href = url;
        }
        else {
          AppConfig.title = AppConfig.community.name;
          AppConfig.update();
        }
      }
      else {
        AppConfig.community.name = AppConfig.title;
        AppConfig.community.slug = oldSlug;
        AppConfig.community.description = oldDesc;
        AppConfig.community.public = oldPublic;
        this.setState({alert: response.message});
      }
    }, 250);

  }

  onRevertInfo() {
    this.setState({
      name: AppConfig.community.name,
      description: AppConfig.community.description,
      slug: AppConfig.community.slug,
      public: AppConfig.community.public,
      editSlug: false
    })
  }

  onOpenIconsDialog() {
    let icon = this.state.icons.indexOf(AppConfig.icon);
    this.setState({showIcons: true, icon})
  }

  onSaveIcon() {
    this.setState({showIcons: false});

    this.setState({message: 'Saving...'});

    setTimeout(async () => {
      AppConfig.community.icon = this.state.icons[this.state.icon];
      let response = await Server.user.updateCommunity(AppConfig.community);
      this.setState({message: ''});
      if(response.success) {
        AppConfig.icon = AppConfig.community.icon;
        AppConfig.update();
      }
      else {
        AppConfig.community.icon = AppConfig.icon;
        this.setState({alert: response.message});
      }
    }, 250);
  }

  onCloseAddMedia(data) {
    console.log(data);

    this.setState({message: 'Saving...', openAddMedia: false});

    setTimeout(async () => {
      if(this.state.editMode == 'logo')
        AppConfig.community.logo = data.url;
      else if(this.state.editMode == 'icon')
        AppConfig.community.icon = data.url;
      else
        AppConfig.community.mobile = data.url;

      let response = await Server.user.updateCommunity(AppConfig.community);

      this.setState({message: ''});
      if(response.success) {
        if(this.state.editMode == 'logo')
          AppConfig.logo = AppConfig.community.logo;
        else if(this.state.editMode == 'icon')
          AppConfig.icon = AppConfig.community.icon;
        else
          AppConfig.mobile = AppConfig.community.mobile;
        AppConfig.update();
      }
      else {
        if(this.state.editMode == 'logo')
          AppConfig.community.logo = AppConfig.logo;
        else if(this.state.editMode == 'icon')
          AppConfig.community.icon = AppConfig.icon;
        else
          AppConfig.community.mobile = AppConfig.mobile;
        this.setState({alert: response.message});
      }
    }, 250);
  }

  renderInfoPanel() {
    let dirty = this.isInfoDirty();

    return (
      <div className="site-page-panel" style={{rowGap: '10px'}}>
        <div className="site-page-column" style={{rowGap: '4px'}}>
          <div>Name</div>    
          <input value={this.state.name} onChange={(e:any)=>this.setState({name: e.currentTarget.value})} />
        </div>
        <div className="site-page-column" style={{rowGap: '4px'}}>
          <div>Description</div>     
          <input value={this.state.description} onChange={(e:any)=>this.setState({description: e.currentTarget.value})} />
        </div>
        <div className="site-page-column" style={{rowGap: '4px'}}>
          <div>Subdomain</div>     
          <div className="site-page-row">
            <input style={{width: '100%'}} disabled={!this.state.editSlug} value={this.state.slug} onChange={(e:any)=>this.setState({slug: e.currentTarget.value})} />
            {!this.state.editSlug && 
              <button className="site-page-icon-button" onClick={()=>this.onEditSlug()}><BsPencilFill/></button>     
            }
            {this.state.editSlug && 
              <button className="site-page-icon-button" onClick={()=>this.onCancelEditSlug()}><BsXLg/></button>     
            }
          </div> 
          <div style={{color: '#00000080', marginLeft: '12px', fontSize: '0.9em'}}>{this.state.slug + '.oneclick.community'}</div>
        </div>
        <div className="site-page-column">
          <div className="site-page-row" style={{marginTop: '5px', columnGap: '5px'}}>
            <input 
              type="checkbox" 
              checked={!this.state.public} 
              onChange={(e:any)=>this.setState({public: !e.currentTarget.checked})}
              style={{width: '20px', height: '20px'}} 
            />
            <div>Private Community</div>
          </div>
        </div>
        <div style={{textAlign: 'right'}}>
          {dirty &&
            <button onClick={()=>this.onRevertInfo()}>Revert</button>
          }
          &nbsp;&nbsp;
          <button onClick={()=>this.onSaveInfo()}>Save</button>
        </div>
      </div>
    )
  }

  renderIconsModal() {
    if(!this.state.showIcons)
      return null;

    let divs = [];
    for(let i = 0; i < this.state.icons.length; i++) {
      let borderColor = (i == this.state.icon) ? '--input-border-color' : '--panel-background-color';
      let style = {width: '50px', border: `2px solid var(${borderColor})`, borderRadius: '6px', padding: '5px'};

      divs.push(
        <img style={style} key={i} src={this.state.icons[i]} onClick={()=>this.setState({icon: i})}></img>
      )
    }
  
    let dirty = this.state.icons[this.state.icon] != AppConfig.icon;

    return (
      <div className="modal open">
        <div className="modal-content">
          <button className="modal-close-button" onClick={()=>this.setState({showIcons: false})}>
            <BsFillXCircleFill />
          </button>
          <div>Select Icon</div>
          <div className="site-page-panel admin-page-icon-dialog">
            {divs}
          </div>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
            <button onClick={()=>this.setState({openAddMedia: true, showIcons: false, editMode: 'icon'})}>Media Library</button>
            <button disabled={!dirty} onClick={()=>this.onSaveIcon()}>Select</button>
          </div>
        </div>
      </div>
    )
  }

  renderSiteIconPanel() {
    return (
      <div className="site-page-panel" style={{paddingTop: '6px', paddingBottom: '5px'}}>
        <div style={{display: 'grid', gridTemplateColumns: '70px 1fr 45px', alignItems: 'center'}}>
          <div>Icon</div>
          <div>
            <img 
              className="site-page-icon-button" 
              style={{maxWidth: '50px', height: '50px', padding: '5px', marginTop: '4px', cursor: 'pointer'}} 
              src={AppConfig.icon}
              onClick={()=>this.onOpenIconsDialog()}
              />
          </div>
          <button 
            className="site-page-icon-button" 
            style={{marginLeft: '5px', maxHeight: '40px'}} 
            onClick={()=>this.onOpenIconsDialog()}
          >
            <BsThreeDots/>
          </button>
        </div>
      </div>
    )
  }

  renderAppIconPanel() {
    return (
      <div className="site-page-panel" style={{paddingTop: '6px', paddingBottom: '5px'}}>
        <div style={{display: 'grid', gridTemplateColumns: '70px 75px 1fr 45px', alignItems: 'center'}}>
          <div>Mobile Icon</div>
          <div>
            <img 
              className="site-page-icon-button" 
              style={{maxWidth: '50px', height: '50px', padding: '5px', marginTop: '4px', cursor: 'pointer'}} 
              src={AppConfig.mobile}
              onClick={()=>this.setState({openAddMedia: true, showIcons: false, editMode: 'install'})}
              />
          </div>
          <div className="site-page-subtext">
            Must be 256x256
          </div>
          <button 
            className="site-page-icon-button" 
            style={{marginLeft: '5px', maxHeight: '40px'}} 
            onClick={()=>this.setState({openAddMedia: true, showIcons: false, editMode: 'install'})}
          >
            <BsThreeDots/>
          </button>
        </div>
      </div>
    )
  }

  renderLogoPanel() {
    return (
      <div className="site-page-panel" style={{paddingTop: '6px', paddingBottom: '5px'}}>
        <div style={{display: 'grid', gridTemplateColumns: '70px 1fr 45px', alignItems: 'center'}}>
          <div>Logo</div>
          <div>
            <img 
              className="site-page-icon-button" 
              style={{width: '150px', height: '50px', objectFit: 'contain', padding: '8px', marginTop: '4px', cursor: 'pointer'}} 
              src={AppConfig.logo}
              onClick={()=>this.setState({openAddMedia: true, editMode: 'logo'})}
              />
          </div>
          <button 
            className="site-page-icon-button" 
            style={{marginLeft: '5px', maxHeight: '40px'}} 
            onClick={()=>this.setState({openAddMedia: true, editMode: 'logo'})}
          >
            <BsThreeDots/>
          </button>
        </div>
      </div>
    )
  }

  renderThemeColors(theme:any) {
    let colorDivs = [];
    for(let j = 0; j < theme.palette.length; j++) {
      colorDivs.push(
        <div 
          key={j} 
          style={{
            backgroundColor: theme.palette[j],
            flex: '1'
          }} 
        ></div>
      )
    }

    return(
      <div className="site-page-panel" style={{
        overflow: 'hidden', 
        height: '38px', 
        borderRadius: '6px', 
        display: 'grid', 
        gridAutoFlow: 'column',
        padding: '0px'
      }}>
        {colorDivs}
      </div>
    )
  }

  renderThemePanel() {
    return (
      <div className="site-page-panel" style={{rowGap: '5px'}}>
        <div>Theme</div> 
        <div style={{display: 'grid', gridTemplateColumns: '1fr 45px'}}>
          <div style={{cursor: 'default'}}>
            {this.renderThemeColors(AppConfig.theme)}
          </div>
          <NavLink to="/admin/theme">
            <button className="site-page-icon-button" style={{marginLeft: '5px'}} >
              <BsFillCaretRightFill/>
            </button>
          </NavLink>
        </div>
      </div>
    )
  }

  renderPagesPanel() {
    return (
      <div className="site-page-panel">
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
          <div>
            Pages
            <div style={{fontSize: '0.9em', color: '#00000080', marginTop: '4px'}}>
              Add custom pages to the site
            </div>
          </div>
          <NavLink to="/admin/pages">
            <button className="site-page-icon-button">
              <BsFillCaretRightFill/>
            </button>
          </NavLink>
        </div>
      </div>
    )
  }

  renderMembersPanel() {
    return (
      <div className="site-page-panel">
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
          <div>
            Members
            <div style={{fontSize: '0.9em', color: '#00000080', marginTop: '4px'}}>
              There are 5 community members
            </div>
          </div>
          <NavLink to="/admin/members">
            <button className="site-page-icon-button">
              <BsFillCaretRightFill/>
            </button>
          </NavLink>
        </div>
      </div>
    )
  }

  render() {
    if(!Server.account.isLoggedIn())
      return(<Navigate replace to="/" />);

    if(Server.user.getRole() != 'admin')
      return(<NotFoundPage />);

    return(
      <div className="site-page">
        <PageEnvelope width="450px">
          <div className="site-page-column">
            {this.renderInfoPanel()}
            {this.renderSiteIconPanel()}
            {this.renderAppIconPanel()}
            {this.renderLogoPanel()}
            {this.renderThemePanel()}
            {this.renderIconsModal()}
          </div>
        </PageEnvelope>
        <MessageModal message={this.state.message}/>
        <AlertModal message={this.state.alert} button="OK" onClose={()=>this.setState({alert: ''})} />
        <AddMediaModal open={this.state.openAddMedia} onClose={()=>this.setState({openAddMedia: false})} callback={(data:any)=>this.onCloseAddMedia(data)} />
      </div>
    )
  }
}

export default AdminPage;